import { z } from "zod";

// Nicotine Usage Schema
export const nicotineUsageSchema = z
    .string()
    .min(1, { message: "This field is required" })
    .transform((val) => val === "true");
